"use client"

import clsx from "clsx"

import type { InferReturn, PropsWithClassName } from "~/@types/generics"
import type { TProductHeaderProduct } from "~/components/ui/Product/ProductHeader/_data/serializer"
import { getOptionWithoutColor } from "~/components/ui/Product/ProductHeader/_data/utils/get-uniq-variants-without-color"
import { getVariantFromOption } from "~/components/ui/Product/ProductHeader/_data/utils/get-variant-from-option"
import getVariantFromParams from "~/components/ui/Product/ProductHeader/ProductDetails/ProductSelector/utils/get-variant-from-params"
import type { useVariantSwitch } from "~/app/[locale]/products/[slug]/_hooks/use-variant-switch"

import { sprinkles, type Sprinkles } from "~/styles/sprinkles.css"
import { text } from "~/styles/variants"

import * as css from "./styles.css"

type ProductPriceProps = PropsWithClassName<{
  sprinklesCss?: Sprinkles
  productHeader: TProductHeaderProduct
  currentMultipleOptions?: InferReturn<typeof useVariantSwitch>["currentProductMultipleOptions"]
}>

export function ProductPrice({ className, sprinklesCss, productHeader, currentMultipleOptions }: ProductPriceProps) {
  const variantFromParams =
    getVariantFromParams(productHeader?.variants, currentMultipleOptions) ?? productHeader?.variants?.[0] ?? null

  const defaultVariant = variantFromParams ?? productHeader?.variants?.[0] ?? null

  const currentOption = defaultVariant ? getOptionWithoutColor(defaultVariant) : null
  const currentVariant = getVariantFromOption(productHeader?.variants, currentOption?.id)

  const price = currentVariant?.price ?? null
  const priceWithoutReduction = currentVariant?.compareAtPrice ?? null

  return (
    <p
      className={clsx(
        css.price,
        text({
          design: "riposte-13",
          weight: "medium",
          transform: "uppercase",
          color: "blue-deep",
          lineHeight: 1,
          letterSpacing: 1,
        }),
        className,
        sprinkles(sprinklesCss ?? {})
      )}
      data-comp="UI/Product/ProductHeader/ProductDetails/ProductPrice"
    >
      {priceWithoutReduction && (
        <>
          <span className={css.priceWithoutReduction}>{priceWithoutReduction}</span>
          {"  "}
        </>
      )}
      {price}
    </p>
  )
}
